import script from "./OfferingComponent.vue?vue&type=script&setup=true&lang=js"
export * from "./OfferingComponent.vue?vue&type=script&setup=true&lang=js"

import "./OfferingComponent.vue?vue&type=style&index=0&id=0b1e1fb0&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-0b1e1fb0"]])

export default __exports__